import logo from './logo.svg';
import './App.css';
import * as ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import AccountDeletion from './screens/AccountDeletion';
import PrivacyPolicy from './screens/PrivacyPolicy';
import Contact from './screens/Contact';

const router = createBrowserRouter([
  {
    path: "/",
    element: <PrivacyPolicy />
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />
  },
  {
    path: "/delete-account",
    element: <AccountDeletion />
  },
  {
    path: "/contact",
    element: <Contact />
  },
]);

function App() {
  return (
    <RouterProvider router={router} />
  );
}

export default App;
